// export const gsurl = "https://script.google.com/macros/s/AKfycbzJaPoaCCV6poRyNpx6_zF8xvYFGGnyvWDPQwacmUhdeTlDIW2NTSnhJ0R7kynphJ4hwA/exec";
// first working
// const gsurl0 = "https://script.google.com/macros/s/AKfycbzT976bmReCMir7Ths6BzkKScWlkyivbHTZy-8j0cO79K7HEWLfrGYMEhzJGTTsToWz/exec";
// added EXPOSESLUG
// const gsurl2 = "https://script.google.com/macros/s/AKfycbyCWNoKzSB32IkT9yCgWrwjnZCeSEILFeWlN9exIXRIDwVJagDLZBwU-ni49SC0BtUY/exec";
// remove number of files limitation: AKfycbyVIuWttE6c_5a1NSgs2Za_58edbnt4mYLUxz1FOCN7FhdpSaDDTEQqTYd2ypPesTE1
// const gsurl3 = "https://script.google.com/macros/s/AKfycbyVIuWttE6c_5a1NSgs2Za_58edbnt4mYLUxz1FOCN7FhdpSaDDTEQqTYd2ypPesTE1/exec";
// increase number of spreadsheet rows from 200 to 499
const gsurl4 = 'https://script.google.com/macros/s/AKfycbwUPwxF6ddrnDBjPgvfZq-AU1wJtggR3BGUJa3KuYjWI4gQQTkDzcQZ7ajk8P1IrW01/exec'
export const gsurl = gsurl4;
// wordpress
// const wpurl0 = 'https://public-api.wordpress.com/wp/v2/sites/angrycarrots.wordpress.com'
const wpurl1 = 'https://public-api.wordpress.com/wp/v2/sites/stevenjayart.wordpress.com'
export const wpurl = wpurl1;